import { Tooltip } from '@mantine/core'

/**
 * The orange dot the settings navigation puts next to controls only our team
 * can see, so a screen-share never passes one off as customer-facing.
 */
const AdminOnlyDot = ({ label = 'Admin only' }: { label?: string }) => (
  <Tooltip label={label}>
    <div
      aria-label={label}
      className="h-1 w-1 shrink-0 rounded-full bg-doubleNickel-error-400"
    />
  </Tooltip>
)

export default AdminOnlyDot
